import { Box } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledSidebar = styled(Box)<{ mobile?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ mobile, theme }) =>
    !mobile &&
    `
    &::before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    background-color: ${theme.colors.cross.ultralightGray};
    width: 100%;
    height: 100%;
    z-index: 0;
    transform: translateX(${rem('-40px')});
  }

  & * {
    position: relative;
    z-index: 1;
  }
  `}

  ${({ mobile }) =>
    mobile &&
    `
    height: 100%;
    padding-top: ${rem('104px')}
  `}
`;

export const StyledStepsInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem('32px')};
`;
